import { render, staticRenderFns } from "./HomeworkInfo.vue?vue&type=template&id=08383c9b&scoped=true&"
import script from "./HomeworkInfo.vue?vue&type=script&lang=js&"
export * from "./HomeworkInfo.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkInfo.vue?vue&type=style&index=0&id=08383c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08383c9b",
  null
  
)

export default component.exports